var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallbackShiftBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_745_3519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_745_3519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 2.50037C12.8334 2.66552 12.7694 2.81156 12.6544 2.92671L9.49849 6.09214C9.38556 6.20508 9.24248 6.27161 9.07667 6.27163C8.91492 6.27163 8.76839 6.20835 8.65485 6.09214L7.1747 4.6125C7.0562 4.494 6.99592 4.3444 7.00024 4.17911C7.00458 4.01416 7.07243 3.87122 7.18425 3.7593C7.29944 3.64411 7.44582 3.57983 7.6111 3.57981C7.7557 3.57981 7.88581 3.62871 7.9932 3.71807L8.03795 3.7593L8.03845 3.7598L9.07667 4.80707L11.8107 2.07352C11.9236 1.96067 12.0668 1.89453 12.2325 1.89453C12.3956 1.89459 12.5435 1.95892 12.6574 2.07704L12.6569 2.07754C12.77 2.19222 12.8333 2.33666 12.8334 2.50037Z",
    fill: "#545556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0526 12.8306C9.83677 12.8306 8.63558 12.5665 7.45152 12.0357C6.26501 11.505 5.18614 10.7541 4.21492 9.78312C3.24369 8.81212 2.49264 7.73105 1.96177 6.54727C1.4309 5.36103 1.16669 4.16013 1.16669 2.94699C1.16669 2.77089 1.2254 2.62658 1.34283 2.50918C1.46026 2.39178 1.60459 2.33308 1.78074 2.33308H4.14397C4.28097 2.33308 4.40084 2.37955 4.50849 2.47249C4.61613 2.56544 4.67974 2.67305 4.69686 2.80024L5.07605 4.84252C5.09562 4.99905 5.09073 5.12868 5.06138 5.2363C5.03202 5.34391 4.9782 5.43441 4.89991 5.51268L3.48589 6.94105C3.67915 7.30059 3.91156 7.6479 4.17822 7.98298C4.44488 8.31806 4.7409 8.64091 5.06138 8.95153C5.36228 9.25237 5.67787 9.53119 6.00814 9.79045C6.3384 10.0497 6.68824 10.2845 7.05765 10.4973L8.42764 9.12763C8.51571 9.03958 8.62824 8.97354 8.77014 8.93196C8.91203 8.88794 9.04903 8.87571 9.18603 8.89528L11.1994 9.30373C11.3364 9.34286 11.4465 9.41379 11.5346 9.51407C11.6227 9.61435 11.6667 9.72931 11.6667 9.85649V12.2192C11.6667 12.3953 11.608 12.5396 11.4905 12.657C11.3731 12.7744 11.2288 12.8331 11.0526 12.8331V12.8306ZM3.89199 4.86942L3.6449 3.49975H2.34586C2.39479 3.89842 2.46329 4.2922 2.54891 4.68109C2.63698 5.06998 2.76175 5.45398 2.9281 5.83308L3.89199 4.86942ZM8.15119 11.0501C8.53039 11.2164 8.91692 11.346 9.31079 11.4438C9.70467 11.5417 10.101 11.6053 10.4998 11.6322V10.3481L9.12976 10.0717L8.15119 11.0501Z",
    fill: "#545556"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallbackShiftBadgeIcon);
export default __webpack_public_path__ + "static/media/callback-shift-badge-icon.07fb4312.svg";
export { ForwardRef as ReactComponent };